import Image from "next/image";
import styles from "./AccommodationCard.module.css";
import type { AccommodationItem } from "@/app/student-life/accommodation/types";

type AccommodationCardProps = {
  item: AccommodationItem;
  onViewDetail: (item: AccommodationItem) => void;
  viewDetailLabel: string;
};

export default function AccommodationCard({
  item,
  onViewDetail,
  viewDetailLabel,
}: AccommodationCardProps) {
  return (
    <article className={styles.accommodationCard}>
      <div className={styles.accommodationImageWrap}>
        <Image
          src={item.image}
          alt={item.title}
          width={500}
          height={320}
          className={styles.accommodationImage}
        />
      </div>

      <div className={styles.accommodationBody}>
        <h3 className={styles.accommodationTitle}>{item.title}</h3>

        <button
          type="button"
          className={styles.viewDetailBtn}
          onClick={() => onViewDetail(item)}
        >
          {viewDetailLabel}
        </button>
      </div>
    </article>
  );
}
